/** Self power-up (fx 'aura'): motes rising in the art's colour. */
import { registerFx } from './registry';

const R = Math.random;

registerFx('aura', (host) => ({
  skill: ({ s, sx, sy }) => {
    const c = host.elemColor(s.id);
    for (let k = 0; k < 20; k++)
      host.parts.push({
        x: sx + (R() - 0.5) * 30,
        y: sy - R() * 10,
        vx: (R() - 0.5) * 10,
        vy: -60 - R() * 50,
        g: 0,
        t: 0,
        life: 0.8,
        c: `rgb(${c})`,
        s: R() < 0.4 ? 2 : 1,
      });
    host.fx.push({ type: 'sigil', x: sx, y: sy, t: 0, life: 0.9, r: 22, col: c });
    host.sfx.charge();
  },
}));
